import { render, staticRenderFns } from "./DocumentWork.vue?vue&type=template&id=b44fde66&scoped=true"
import script from "./DocumentWork.vue?vue&type=script&lang=js"
export * from "./DocumentWork.vue?vue&type=script&lang=js"
import style0 from "./DocumentWork.vue?vue&type=style&index=0&id=b44fde66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44fde66",
  null
  
)

export default component.exports